import { AuthContextType, DispatchAuthenticatedUser } from './typeDefs';
import { createContext } from 'react';

export const AuthenticatedUserContext = createContext<AuthContextType | undefined>(undefined);
export const DispatchAuthenticatedUserContext = createContext<DispatchAuthenticatedUser | undefined>(undefined);
